// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchTerm_wrapper__LKa8e","title":"SearchTerm_title__BB842","body":"SearchTerm_body__OY2KZ"};